import
  React
from 'react';

import
  styled
from 'styled-components';

import
  PropTypes
from 'prop-types';

import {
  HContainer,
  Image,
  Text,
  VFillContainerV,
  VFillContainerVH
} from '@vodacom/web-common';

import {
  HandleRender
} from 'hocs';

import {
  CustomColors,
  ErrorKeys
} from '../../../../constants';

const ImageContainer = styled(Image)`
  max-height: ${props => props.maxHeight};
  max-width: ${props => props.maxWidth};
`;

export const VoucherCard = (props) => {

  const Content = () => {

    return (

      <HContainer
        width={props.cardWidth}
        height={props.cardHeight}
        maxHeight={props.cardMaxHeight}
        maxWidth={props.cardMaxWidth}
        margin={props.margin}
        boxShadow={props.boxShadow}
        overflow={'hidden'}
        borderRadius={props.borderRadius}
        onClick={props.onClick}
        position={'relative'}>

        { !!props.badge &&
          <HContainer
            top={'0'}
            right={'0'}
            position={'absolute'}
            padding={'4px 16px'}
            borderRadius={'0 0 0 8px'}
            backgroundColor={CustomColors.Green5}>

            <Text
              color={CustomColors.White}
              fontSize={'10px'}
              lineHeight={'12px'}>

              {props.badge}
            </Text>
          </HContainer>
        }

          <HContainer
            width={'130px'}
            maxWidth={props.imageMaxWidth}
            maxHeight={props.imageMaxHeight}>

            <VFillContainerVH
              width={'100%'}
              backgroundColor={CustomColors.Grey13}>

              <HContainer
                maxWidth={props.logoMaxWidth}
                maxHeight={props.logoMaxHeight}>

                <ImageContainer
                  src={props.logo}
                  width={'auto'}
                  height={'auto'}
                  maxWidth={props.logoMaxWidth}
                  maxHeight={props.logoMaxHeight}/>
              </HContainer>

              <HContainer
                margin={'8px 0 0'}
                >

                <Text
                  fontSize={props.voucherValueSize}
                  color={props.voucherValueColor}
                  fontWeight={props.voucherValueWeight}
                  lineHeight={props.voucherValueLineHeight}>

                    {props.voucherValue}
                </Text>
              </HContainer>

              <Text
                fontSize={props.voucherValueSubSize}
                color={props.voucherValueSubColor}
                fontWeight={props.voucherValueSubWeight}
                lineHeight={props.voucherValueSubLineHeight}
                dangerouslySetInnerHTML={{
                  __html: props.voucherValueSub
                }} />
            </VFillContainerVH>

            <VFillContainerV
              textAlign={'left'}
              padding={'0 0 0 24px'}
              width={'200px'}>

              <VFillContainerV/>

              <VFillContainerV>

                <Text
                  fontSize={props.titleSize}
                  color={props.titleColor}
                  fontWeight={props.titleWeight}
                  lineHeight={props.titleLineHeight}>

                  {props.title}
                </Text>

                <Text
                  fontSize={props.subtitleSize}
                  color={props.subtitleColor}
                  fontWeight={props.subtitleWeight}
                  lineHeight={props.subtitleLineHeight}>

                  {props.subtitle}
                </Text>
              </VFillContainerV>

                <Text
                  fontSize={props.finePrintSize}
                  padding={props.finePrintPadding}
                  color={props.finePrintColor}
                  fontWeight={props.finePrintWeight}
                  lineHeight={props.finePrintLineHeight}>

                  {props.finePrint}
                </Text>

            </VFillContainerV>

          </HContainer>

      </HContainer>
    );
  };

  return (

    <HandleRender
      isLoading={props.isLoading}
      isError={props.isError}
      error={{
        type: ErrorKeys.Empty
      }}>

        {
          <Content/>
        }
    </HandleRender>
  );
};

VoucherCard.propTypes = {
  badge: PropTypes.string,
  borderRadius: PropTypes.string,
  boxShadow: PropTypes.string,
  cardHeight: PropTypes.string,
  cardMaxHeight: PropTypes.string,
  cardMaxWidth: PropTypes.string,
  cardWidth: PropTypes.string,
  image: PropTypes.string,
  imageHeight: PropTypes.string,
  imageMaxHeight: PropTypes.string,
  imageMaxWidth: PropTypes.string,
  imageWidth: PropTypes.string,
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  logo: PropTypes.string,
  logoHeight: PropTypes.string,
  logoMaxHeight: PropTypes.string,
  logoMaxWidth: PropTypes.string,
  logoWidth: PropTypes.string,
  margin: PropTypes.string,
  subtitleColor: PropTypes.string,
  subtitleLineHeight: PropTypes.string,
  subtitleSize: PropTypes.string,
  subtitleWeight: PropTypes.string,
  title: PropTypes.string,
  titleColor: PropTypes.string,
  titleLineHeight: PropTypes.string,
  titleSize: PropTypes.string,
  titleWeight: PropTypes.string,
  finePrint: PropTypes.string,
  finePrintColor: PropTypes.string,
  finePrintLineHeight: PropTypes.string,
  finePrintSize: PropTypes.string,
  finePrintWeight: PropTypes.string,
  finePrintPadding: PropTypes.string,
  voucherValueSub: PropTypes.string,
  voucherValueSubColor: PropTypes.string,
  voucherValueSubLineHeight: PropTypes.string,
  voucherValueSubSize: PropTypes.string,
  voucherValueSubWeight: PropTypes.string,
  voucherValue: PropTypes.string,
  voucherValueColor: PropTypes.string,
  voucherValueLineHeight: PropTypes.string,
  voucherValueSize: PropTypes.string,
  voucherValueWeight: PropTypes.string
};

VoucherCard.defaultProps = {
  badge: 'ADVANCE VOUCHER',
  borderRadius: '8px',
  boxShadow: `0px 4px 4px ${CustomColors.TransparentBlack1}`,
  cardHeight: '150px',
  cardMaxHeight: '150px',
  cardMaxWidth: '100%',
  cardWidth: '100%',
  image: '',
  imageHeight: '100%',
  imageMaxHeight: '100%',
  imageMaxWidth: '150px',
  imageWidth: '100%',
  isError: false,
  isLoading: true,
  logo: '',
  logoHeight: '100%',
  logoMaxHeight: '36px',
  logoMaxWidth: '54px',
  logoWidth: '100%',
  margin: '8px 0',
  subtitle: 'Subtitle',
  subtitleColor: CustomColors.Grey7,
  subtitleLineHeight: '20px',
  subtitleSize: '12px',
  subtitleWeight: '400',
  finePrint: '* valid for 30 days - Single redemption voucher',
  finePrintColor: CustomColors.Grey9,
  finePrintLineHeight: '10px',
  finePrintSize: '9px',
  finePrintWeight: '400',
  finePrintPadding: '0 0 16px',
  title: 'Title',
  titleColor: CustomColors.Black,
  titleLineHeight: '20px',
  titleSize: '26px',
  titleWeight: '700',
  voucherValueSub: 'Voucher',
  voucherValueSubColor: CustomColors.Grey7,
  voucherValueSubLineHeight: '18px',
  voucherValueSubSize: '10px',
  voucherValueSubWeight: '400',
  voucherValue: 'R0',
  voucherValueColor: CustomColors.Grey9,
  voucherValueLineHeight: '32px',
  voucherValueSize: '26px',
  voucherValueWeight: '700'
};
